class ShopifyTheme {
  static EVENTS = {
    COOKIE_CONSENT: 'cookie:consent',
  };
  static loadCustomerPrivacy = () => {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          throw new Error(error);
        } else {
          window.Shopify.customerPrivacy.setTrackingConsent(false, () => {
            console.log('Tracking consent set to false', window.Shopify.customerPrivacy.userCanBeTracked());
          });
        }
      }
    );
  }

  static iubendaIntegration = (preferences) => {
    const isPrefEmpty = !preferences || Object.keys(preferences).length === 0;
    const consent = isPrefEmpty ? _iub.cs.api.getPreferences() : preferences;
    const shopifyPurposes = {
      "analytics": [4, 's'],
      "marketing": [5, 'adv'],
      "preferences": [2, 3],
      "sale_of_data": ['s', 'sh'],
    }
    const expressedConsent = {};
    Object.keys(shopifyPurposes).forEach(function(purposeItem) {
      var purposeExpressed = null
      shopifyPurposes[purposeItem].forEach(item => {
        if (consent.purposes && typeof consent.purposes[item] === 'boolean') {
          purposeExpressed = consent.purposes[item];
        }
        if (consent.uspr && typeof consent.uspr[item] === 'boolean' && purposeExpressed !== false) {
          purposeExpressed = consent.uspr[item];
        }
      })

      if (typeof purposeExpressed === 'boolean') {
        expressedConsent[purposeItem] = purposeExpressed;
      }
    });
    console.log('expressedConsent', expressedConsent);
    window.Shopify.customerPrivacy.setTrackingConsent(expressedConsent, function() {
      window.dispatchEvent(new CustomEvent(ShopifyTheme.EVENTS.COOKIE_CONSENT, {
        detail: expressedConsent
      }));
    });
  }
}